import { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { isSentForDesking } from '@makemydeal/dr-sales-checkin-utils';
import { getWorkflowInputsFromState } from '../workflowInputs';
import type { WorkflowRule } from '../types';

// Showroom mode: the manager has been asked to desk the deal. Evaluated *after* acceptedRule and
// deskedRule, because one of its arms — a trade-in deal with an outstanding approval request —
// survives a live published version and so overlaps both. See `isSentForDesking` for the three arms.
export const sentForDeskingRule: WorkflowRule = (state: any): WorkflowStatus | null =>
    isSentForDesking(getWorkflowInputsFromState(state)) ? WorkflowStatus.SENT_FOR_DESKING : null;
